<template>
    <el-dialog
        title="修改申请"
        :visible.sync="fundRequestVisible"
        width="600px"
        class="fundRequestDialog"
        :close-on-click-modal="!editFlag"
        :before-close="closeDialogOnly"
    >
        <div class="carryBox" v-loading="loading">
            <el-form
                ref="fundReqForm"
                :rules="rules"
                :model="fundReqForm"
                label-width="80px"
                hide-required-asterisk
            >
                <el-form-item label="客户地址：">{{receiverDetailAddr}}</el-form-item>
                <el-form-item label="预计里程：">
                    <span>{{fundReqForm.planMile}} KM</span>
                </el-form-item>
                <el-form-item label="费用：">{{fundReqForm.fee}}</el-form-item>
                <el-form-item prop="actMile" label="实际里程：">
                    <span v-if="!editFlag">{{fundReqForm.actMile}} KM</span>
                    <div v-if="editFlag" class="actMileBox">
                        <el-button-group>
                            <el-button
                                icon="el-icon-minus"
                                @click="()=>{--fundReqForm.actMile;editMile()}"
                            ></el-button>
                            <el-input
                                v-model.number="fundReqForm.actMile"
                                @input="editMile()"
                                maxlength="10"
                            ></el-input>
                            <el-button
                                icon="el-icon-plus"
                                @click="()=>{++fundReqForm.actMile;editMile()}"
                            ></el-button>
                        </el-button-group>
                        <div class="uploadWarning" v-show="showUpload">超出预计里程5KM需上传附件</div>
                    </div>
                    <el-button v-show="editFlag" @click="initMile" class="editButton" size="mini">重置</el-button>
                </el-form-item>
                <el-form-item label="驳回原因：" v-show="rowData.rejectFeeReason">{{rowData.rejectFeeReason}}</el-form-item>
            </el-form>
            <div class="uploader" v-show="showUpload">
                <div class="viewerBox" v-show="imgArr.length">
                    <ul id="viewers">
                        <li v-for="(item, index) in imgArr" :key="index">
                            <img :src="item.url" />
                        </li>
                    </ul>
                </div>
                <div class="emptyImgBox" v-show="!imgArr.length">
                    <i class="el-icon-picture"></i>
                </div>
                <div class="uploader toolBar">
                     <upload-new-btn
                        ref="signUpload"
                        class="uploadBtn"
                        type="btn"
                        multiple
                        businessKey="default"
                        bucket="c-tms"
                        contentType="application/octet-stream"
                        :needBtn="false"
                        :limit="3"
                        :publicRead="1"
                        :compressImage="true"
                        :compressQuality="0.5"
                        @beforeUpload="beforeUpload"
                        @callback="uploadResponse"
                    >
                        <i class="el-icon-plus pictures"></i>
                    </upload-new-btn>
                    <el-popover
                            placement="bottom"
                            width="160"
                            v-show="imgArr.length > 1"
                            v-model="confirmVisible"
                            trigger="click">
                        <p> <i class="el-icon-info" style="color:red"></i> 确定删除当前图片？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button type="text" size="mini" @click="confirmVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="deleteBtn">确定</el-button>
                        </div>
                        <i class="el-icon-delete smallBtn" slot="reference"></i>
                    </el-popover>
                    <i class="el-icon-download smallBtn" @click="downloadBtn" v-show="imgArr.length"></i>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="saveFundRequest" :disabled="loading">修 改</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import api from '../../../../api/netTaskManage2c.js';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    components: { UploadNewBtn },
    data() {
        return {
            loading: false,
            editFlag: true,
            showUpload: false,
            confirmVisible: false,
            fundRequestVisible: false,
            limit: 3,
            imgArr: [],
            tempFee: 0,
            tempActMile: 0,
            carouselIndex: 0,
            rowData: {},
            receiverDetailAddr: '',
            fundReqForm: {
                planMile: 0,
                fee: 0,
                actMile: 0
            },
            rules: {
                fee: [
                    { required: true, message: '请输入费用', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        async show(rowData) {
            this.fundRequestVisible = true;
            this.loading = true;
            this.rowData = rowData;
            this.receiverDetailAddr = rowData.receiverDetailAddr;
            await api
                .getPlanMile(rowData.orderNo)
                .then((res) => {
                    if (res && res.code === '0') {
                        const calculateMile = Math.ceil(res.data / 1000);
                        this.fundReqForm.planMile = calculateMile;
                        this.fundReqForm.actMile = rowData.actMile;
                        this.tempActMile = rowData.actMile;
                        if (rowData.actMile > 20) {
                            this.fundReqForm.fee = rowData.actMile - 20;
                            this.tempFee = rowData.actMile - 20;
                        } else {
                            this.fundReqForm.fee = 0;
                            this.tempFee = 0;
                        }
                    } else {
                        this.closeDialogOnly();
                    }
                })
                .catch(() => {
                    this.closeDialogOnly();
                });
            this.editMile();
            this.loading = false;
        },
        updateImgList() {
            if (this.viewer.images) this.viewer.destroy();
            this.getUpdateImgList();
        },
        async getUpdateImgList() {
            // 图片上传成功只处理刷新图片部分
            this.loading = true;
            this.closeOnClickModal = true;
            const params = {
                orderNo: this.rowData.orderNo,
                // type:10用于存储费用申请附件
                type: '10'
            };
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.imgArr = res.data.images.reverse() || [];
                        this.updateViewer();
                    }
                })
                .catch(() => {});

            this.closeOnClickModal = false;
            this.loading = false;
        },
        updateViewer() {
            this.carouselIndex = 0;
            if (this.viewer) this.viewer.destroy();
            this.$nextTick(() => {
                this.initViewer();
            });
        },
        // 删除图片
        async deleteBtn() {
            this.loading = true;
            const imageId = this.imgArr[this.carouselIndex].id;
            this.loading = true;
            await api
                .delImages(imageId)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.imgArr.splice(this.carouselIndex, 1);
                        this.$message.success('删除成功');
                        this.updateViewer();
                    }
                })
                .catch(() => {});
            this.confirmVisible = false;
            this.loading = false;
        },
        initMile() {
            this.fundReqForm.actMile = this.tempActMile;
            this.fundReqForm.fee = this.tempFee || 0;
            // this.editFlag = this.fundReqForm.actMile > 20;
            this.showUpload = this.fundReqForm.actMile - this.fundReqForm.planMile >= 5;
        },
        editMile() {
            this.fundReqForm.actMile - this.fundReqForm.planMile >= 5
                ? this.showUploadBox(true)
                : this.showUploadBox(false);
            if (this.fundReqForm.actMile > 20) {
                this.fundReqForm.fee = this.fundReqForm.actMile - 20;
            } else {
                this.fundReqForm.fee = 0;
            }
        },
        showUploadBox(showFlag) {
            if (showFlag && !this.showUpload) {
                this.showUpload = showFlag;
                this.getUpdateImgList();
            } else if (!showFlag) {
                this.showUpload = showFlag;
            }
        },
        downloadBtn() {
            window.location =
                this.imgArr[this.carouselIndex].url;
        },
        initViewer() {
            this.loading = true;
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                view: (info) => {
                    this.carouselIndex = info.detail.index;
                },
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: barOptions,
                    reset: barOptions,
                    next: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
            this.loading = false;
        },
        async uploadResponse(response) {
            const params = {
                orders: this.rowData.orderNo,
                type: '10'
            };
            params.images = response.map((item) => item.data.downUrl);
            await api
                .netUpload(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('上传成功');
                    }
                })
                .catch(() => {});
            this.updateImgList();
            this.loading = false;
        },
        beforeUpload({ file }) {
            const extArr = ['jpg', 'jpeg', 'png', 'tif', 'bmp'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / TIF / BMP',
                    duration: 5000,
                    showClose: true
                });
                return false;
            }
            return file;
        },
        getFileExt(fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        async saveFundRequest() {
            if (this.fundReqForm.actMile === this.tempActMile) return this.$message.warning('实际里程无变化，无法提交');
            let flag = true;
            this.$refs.fundReqForm.validate((value) => {
                flag = value;
            });
            const reg = new RegExp('^[1-9]d*|0$');
            if (!reg.test(this.fundReqForm.actMile)) {
                return this.$message.warning('实际里程必须为正整数');
            }
            if (!flag) return;
            if (
                this.fundReqForm.actMile - this.fundReqForm.planMile >= 5 &&
                this.imgArr.length < 1
            ) {
                this.editFlag = true;
                this.showUploadBox(true);
                return this.$message.warning('超出预计里程5KM需上传附件');
            }
            this.loading = true;
            const applystatus =
                this.fundReqForm.actMile - this.fundReqForm.planMile >= 5
                    ? 1
                    : 2;
            const dataParams = {
                id: this.rowData.id,
                applystatus: applystatus,
                orderNo: this.rowData.orderNo,
                planMile: this.fundReqForm.planMile,
                fee: this.fundReqForm.fee,
                actMile: this.fundReqForm.actMile,
                provinceCode: this.rowData.provinceCode,
                cityCode: this.rowData.cityCode,
                districtCode: this.rowData.districtCode,
                townCode: this.rowData.townCode
            };
            await api.saveApply([dataParams]).then(async(res) => {
                if (res && res.code === '0') {
                    this.$message.success('提交成功');
                    if (applystatus === 2) {
                        await api.sendJiFeiByNet({ orderNo: this.rowData.orderNo }).then(res => {}).catch(() => {});
                    }
                    this.closeAndRefresh();
                }
            }).catch(() => {});
            this.loading = false;
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'fundRequestDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'fundRequestDialog', true);
        }
    }
};
</script>

<style lang="less">
.fundRequestDialog {
    .el-form-item {
        margin-bottom: 0;
    }
    .actMileBox {
        display: inline-block;
        .el-button {
            margin-top: 6px;
            float: left;
        }
        .el-input {
            float: left;
            margin-left: 1px;
            width: 80px;
            .el-input__inner {
                text-align: center;
                border-radius: 0;
                border-left: 0;
                border-right: 0;
            }
        }
        .uploadWarning {
            margin-left: 20px;
            display: inline-block;
            font-size: 12px;
            color: #00bcbf;
        }
    }
    .editButton {
        margin-top: 6px;
        float: right;
    }

    .uploader {
        text-align: center;
        .uploadBtn {
            display: inline-block;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        .smallBtn {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
            margin-left: 30px;
        }
        .el-upload{
            text-align: center;
        }
    }
    .toolBar {
        margin-top: 10px;
    }
    .viewerBox {
        width: 100%;
        height: 230px;
        .viewer-backdrop {
            background-color: #fff;
        }
        #viewers {
            display: none;
        }
    }

    .emptyImgBox {
        width: 100%;
        font-size: 200px;
        color: #00bcbf;
        text-align: center;
    }

    .receive-imgs {
        width: 100%;
        height: 100%;
    }
}
</style>
